import { Component } from 'react'
import noop from 'utils/noop'

class Uploader extends Component {
  static defaultProps = {
    url: null,
    onComplete: noop,
    onError: noop,
    onProgress: noop,
    onAbort: noop
  }

  state = {
    progress: -1,
    uploading: false
  }

  startUpload = file => {
    this.setState({ uploading: true })

    return new Promise((resolve, reject) => {
      const req = new XMLHttpRequest()
      req.open('PUT', this.props.url, true)

      req.addEventListener(
        'load',
        e => {
          this.setState({
            progress: -1,
            uploading: false
          })
          this.props.onComplete()
          resolve(e)
        },
        false
      )

      req.addEventListener(
        'error',
        e => {
          this.setState({
            hasError: true,
            uploading: false
          })
          // TODO Pass in error properly
          this.props.onError()
          reject(e)
        },
        false
      )

      req.upload.addEventListener(
        'progress',
        e => {
          let progress = 0
          if (e.total !== 0) {
            progress = parseInt((e.loaded / e.total) * 100, 10)
          }
          this.setState({
            progress
          })

          this.props.onProgress({ progress })
        },
        false
      )

      req.addEventListener(
        'abort',
        e => {
          this.setState({
            progress: -1
          })

          this.props.onAbort()
        },
        false
      )

      req.send(file)
    })
  }

  render() {
    return this.props.children({
      startUpload: this.startUpload,
      progress: this.state.progress,
      uploading: this.state.uploading
    })
  }
}

export default Uploader



// WEBPACK FOOTER //
// ./src/components/Uploader.js